export default "__VITE_ASSET__CK7xAK9e__"